<template>
	<div class="pubfooter">
		<div class="info">
			<div class="fixation">
				<div class="safeguard">
					<div class="item">
						<div class="icon">
							<img src="../../../assets/footer-1.png" alt="">
						</div>
						<div class="right">
							<div class="key">如实描述承诺</div>
							<div class="value">送拍机构在发拍品时会履行实物描述义务</div>
						</div>
					</div>
					<div class="item">
						<div class="icon">
							<img src="../../../assets/footer-2.png" alt="">
						</div>
						<div class="right">
							<div class="key">保证金保障</div>
							<div class="value">送拍机构都会缴纳足额保证金来确保安全</div>
						</div>
					</div>
					<div class="item">
						<div class="icon">
							<img src="../../../assets/footer-3.png" alt="">
						</div>
						<div class="right">
							<div class="key">售后服务保障</div>
							<div class="value">送拍机构在发拍品时会履行实物描述义务</div>
						</div>
					</div>
				</div>
				<div class="navigate">
					<div class="left">
						<div class="logo">
							<img src="../../../assets/footer-logo.png" alt="">
						</div>
						<div class="menu">
							<div class="item">
								<router-link to="/index">首页</router-link>
							</div>
							<div class="item" v-for="(item,index) in navigate" :key="index">
								<router-link :to="{path:item.path}">
									{{item.name}}
								</router-link>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="qrcode">
							<img :src="$pub.imageUrl+$store.state.websiteConfig.qrcodeUrl" alt=""><br>
							关注大德拍卖公众号
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="copyright">
			增值电信业务经营许可证：{{$store.state.websiteConfig.zzdxywjyxkz}} |
			<!-- 增值电信业务经营许可证（跨地区）：{{$store.state.websiteConfig.zzdxywjyxkz_kdq}} | -->
			京网文{{$store.state.websiteConfig.jww}}<br>
			<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802040611" rel="nofollow"
				target="_blank">京公网安备{{$store.state.websiteConfig.jwgaba}}</a>
			|
			<a href="https://beian.miit.gov.cn/" rel="nofollow"
				target="_blank">京ICP备{{$store.state.websiteConfig.j_icp}}</a>
			<br>
			Copyright {{$store.state.websiteConfig.copyright_time}} {{$store.state.websiteConfig.web_name}}
			总部地址：{{$store.state.websiteConfig.addressList[0]['address']}}
		</div>
	</div>
</template>

<script>
	export default {
		name: 'pubfooter',
		data() {
			return {
				navigate: [{
						name: '公益拍卖',
						path: '/one'
					},
					{
						name: '拍卖预告',
						path: '/advance'
					},
					{
						name: '拍卖现场',
						path: '/scene'
					},
					{
						name: '拍卖指南',
						path: '/guide'
					},
					{
						name: '法规·资讯',
						path: '/paper'
					},
					{
						name: '关于我们',
						path: '/about'
					}
				],
				info: {}
			};
		},
		methods: {},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.pubfooter {
		width: 100%;
		background: @vue-bg-color;

		.info,
		.copyright {
			width: 100%;
		}

		.safeguard {
			width: 100%;
			height: 150px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid @vue-border-color;
			box-sizing: border-box;

			.item {
				width: 30%;
				height: 50px;
				border-right: 1px solid @vue-border-color;
				display: flex;
				justify-content: space-between;

				.icon {
					width: 50px;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;

					img {
						height: 100%;
						display: block;
					}
				}

				.right {
					width: calc(100% - 70px);
					height: 100%;

					.key {
						width: 100%;
						height: 28px;
						display: flex;
						align-items: center;
						font-size: @vue-font-size-sm + 2;
					}

					.value {
						width: 100%;
						height: 22px;
						display: flex;
						align-items: center;
						font-size: @vue-font-size-min;
						color: @vue-text-color-grey;
					}
				}
			}

			.item:last-child {
				border: none;
			}
		}

		.navigate {
			width: 100%;
			height: 200px;
			display: flex;
			justify-content: space-between;

			.left {
				width: 1000px;
				height: 100%;
				padding: @vue-spacing-col-base*2 0px;
				box-sizing: border-box;

				.logo {
					width: 100%;
					height: 102px;
					padding-top: @vue-spacing-col-sm;
					box-sizing: border-box;
				}

				.menu {
					width: 100%;
					height: 50px;
					display: flex;

					.item {
						height: 100%;
						display: flex;
						align-items: center;

						a {
							height: 24px;
							color: @vue-text-color;
							margin-right: @vue-spacing-row-lg;
							border-right: 1px solid @vue-border-color;
							padding-right: @vue-spacing-row-lg;
							box-sizing: border-box;
						}

						a:hover {
							color: @vue-text-color-active;
						}
					}
				}
			}

			.right {
				width: 200px;
				height: 100%;

				.qrcode {
					width: 140px;
					height: 100%;
					margin: 0 auto;
					font-size: @vue-font-size-sm - 2;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-wrap: wrap;
					align-content: center;

					img {
						width: 110px;
						height: 110px;
					}
				}
			}
		}

		.copyright {
			width: 100%;
			height: 120px;
			background: @vue-bg-color-grey;
			color: @vue-text-color-grey;
			padding-top: 20px;
			box-sizing: border-box;
			text-align: center;
			line-height: 26px;
			font-size: @vue-font-size-sm - 2;

			a {
				color: @vue-text-color-grey;
			}

			a:hover {
				color: @vue-text-color-active;
			}
		}
	}
</style>